import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { getCustomer } from "../bowlers/bowlers.redux";
import styled from "styled-components";
import "../ball/styles.css";
import Spinner from "../ui/Spinner";
import logoSpectre from "../../images/spectre_logo_2022.png";
import { Printer } from "react-bootstrap-icons";
import { getPhotoForUserId } from "../../utils/utils";
import { Row, Col } from "react-bootstrap";
import { divPrint } from "../bowlers/bowlers.redux";
import { connect } from "react-redux";

const ButtonPrint = styled.button`
  border-radius: 4px;
  color: #00197b;
  font-size: 12px;
  font-weight: 600;
  background: transparent;
  border: 1px solid #00197b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px;
  min-width: 50px;
  height: 50px;
`;

const LineRow = styled(Row)`
  height: 0.8in;
  width: 100%;
  border-top: 1.5px solid #000000;
  border-left: none;
  border-right: none;
  justify-content: center;

  & .col {
    padding-left: 0;
    padding-right: 0;
  }
`;

const DivToPrintContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media only screen and (max-width: 768px) {
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    transform: scale(0.45);
    margin-top: -1in;
  }

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    transform: scale(0.45);
    margin-top: -2.475in;
  }
`;

const DivToPrint = styled.div`
  width: 8.5in;
  padding: 0.25in;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  @media only print {
    margin: 0;
    box-shadow: none;
    border: none;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const ProshopInfo = styled.div`
  color: #000000;
  font: normal normal 500 12px/14px Poppins;
  padding: 3px;
`;

const imgPrinterStyle = {
  width: "30px",
  height: "22px",
};

const HeaderRow = styled(Row)`
  height: 1in;
  background-color: transparent;
  align-items: center;
  justify-content: left;
`;

const ImglogoProshop = {
  maxWidth: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const DivPage = styled.div`
  width: 100vw;
  max-width: 9in;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  align-items: center;
  padding-bottom: 5vh;

  @media only print {
    position: absolute;
    top: 0;
    left: 0;
    width: 8in;
    height: 10.5in;
    overflow: visible;
    display: flex;
    flex-direction: column;
    justify-content: center;
    -webkit-print-color-adjust: exact;
  }
`;

const DivHeader = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;

  @media only print {
    display: none;
  }
`;

export const GalleryPrintRedux = (props) => {
  const { selectedCustomer, loadingCustomer, getCustomer, proshop, userInfo } =
    props;

  const printPageRef = useRef(null);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const bowlerID = params.bowlerID;
  const attachmentIndex = params.attachmentIndex;
  const isSSR = typeof window === "undefined";

  useEffect(() => {
    if (!selectedCustomer) {
      getCustomer({
        customer_id: bowlerID,
      });
    }
  }, [selectedCustomer]);

  const getPhoto = getPhotoForUserId(userInfo?.id);
  const proshopLogo = getPhoto(proshop?.logo);

  return loadingCustomer ? (
    <Spinner />
  ) : (
    <DivPage>
      <DivHeader>
        <ButtonPrint onClick={() => window.print()}>
          <Printer style={imgPrinterStyle} />
          <span style={imgPrinterStyle}>{t("Print")}</span>
        </ButtonPrint>
      </DivHeader>
      <DivToPrintContainer ref={printPageRef}>
        <DivToPrint>
          <HeaderRow>
            <Col
              xs="3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={proshopLogo}
                style={ImglogoProshop}
                alt="Logo Proshop"
              />
            </Col>
            <Col xs="6">
              <ProshopInfo>{proshop?.name || ""}</ProshopInfo>
              <ProshopInfo>{proshop?.address || ""}</ProshopInfo>
              <ProshopInfo>{`${proshop?.city || ""}${
                proshop?.state ? "," : ""
              } ${proshop?.state || ""}${proshop?.postal_code ? "," : ""} ${
                proshop?.postal_code || ""
              }`}</ProshopInfo>
              <ProshopInfo>{userInfo?.phone || ""}</ProshopInfo>
              <ProshopInfo>{userInfo?.website || ""}</ProshopInfo>
            </Col>
            <Col xs="3">
              <img
                src={logoSpectre}
                style={ImglogoProshop}
                alt="Logo Spectre"
              />
            </Col>
          </HeaderRow>
          <LineRow>
            {selectedCustomer?.gallery && (
              <Col xs="12">
                <img
                  src={getPhoto(
                    `${
                      selectedCustomer?.gallery[attachmentIndex]
                    }?ttl=${Date().toString()}`
                  )}
                  alt="Attachment"
                />
              </Col>
            )}
          </LineRow>
        </DivToPrint>
      </DivToPrintContainer>
    </DivPage>
  );
};

export const GalleryPrint = connect(
  (state) => {
    const appSettings = state.settings.appSettings;
    return {
      selectedCustomer: state.bowlers.selectedCustomer,
      loadingCustomer: state.bowlers.loadingCustomer,
      proshop: state.userSession.proshop,
      userInfo: state.userSession.userData,
      state: state,
      appSettings,
    };
  },
  {
    getCustomer,
    divPrint,
  }
)(GalleryPrintRedux);
